export const buildTagHierarchyFromFacets = (
	allTags: (Site.SiteTagFolder | Site.SiteTag)[],
	facets: { name: string }[], // Is all the tags related to the items
): (Site.SiteTagFolder | Site.SiteTag)[] => {
	const facetNames = facets.map((f) => f.name);

	const filterChildren = (items?: (Site.SiteTagFolder | Site.SiteTag)[]) => {
		if (!items) return [];
		const added: string[] = [];

		return items
			.map((tag) => {
				const children = 'children' in tag ? filterChildren(tag.children) : [];
				const isAllowed = facetNames.includes(tag.name);

				if ((isAllowed || children.length) && !added.includes(tag.name)) {
					added.push(tag.name);
					return { ...tag, ...(children.length ? { children } : {}) };
				}
				return null;
			})
			.filter(Boolean) as (Site.SiteTagFolder | Site.SiteTag)[];
	};

	return allTags
		.map((tag) => {
			if (!('children' in tag)) return facetNames.includes(tag.name) ? tag : null;
			const children = filterChildren(tag.children);
			return children.length ? { ...tag, children } : null;
		})
		.filter(Boolean) as (Site.SiteTagFolder | Site.SiteTag)[];
};
